<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Client</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="saveStudent">
            <!-- Student Type -->
            <label>Client Type <span class="required">*</span></label>
            <select v-model="student.student_type" class="form-control" required>
                <option value="IOP">IOP</option>
                <option value="OTP">OTP</option>
                <option value="BOTH">BOTH</option>
            </select>
            <div v-if="errors.student_type" class="error-message">{{ errors.student_type[0] }}</div>

            <!-- PID -->
            <label> Presentive/Methasoft ID <span class="required">*</span></label>
            <input type="text" v-model="student.pid" placeholder=" Presentive ID" required>
            <div v-if="errors.pid" class="error-message">{{ errors.pid[0] }}</div>

            <!-- Full Name -->
            <label>Full Name <span class="required">*</span></label>
            <input type="text" v-model="student.name" placeholder="Full Name" required>
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <!-- DOB -->
            <label>Date of Birth</label>
            <input type="date" v-model="student.dob" placeholder="Date of birth">
            <div v-if="errors.dob" class="error-message">{{ errors.dob[0] }}</div>

            <!-- Pin Code -->
            <!-- <label>Pin Code <span class="required">*</span></label>
            <input type="text" v-model="student.pin_code" placeholder="4-digit Pin Code" required pattern="\d{4}"
                maxlength="4"> -->
            <!-- <div v-if="errors.pin_code" class="error-message">{{ errors.pin_code[0] }}</div> -->

            <!-- Conditional Counselor or Group -->
            <div v-if="student.student_type === 'OTP'">
                <label>Counselor </label>
                <select v-model="student.counselor_id" class="form-control">
                    <option disabled value="">Select a counselor</option>
                    <option v-for="counselor in counselors" :key="counselor.id" :value="counselor.id">
                        {{ counselor.user?.name }}
                    </option>
                </select>
                <div v-if="errors.counselor_id" class="error-message">{{ errors.counselor_id[0] }}</div>
            </div>
            <div v-else>
                <label>Group </label>
                <select v-model="student.group_id" class="form-control">
                    <option disabled value="">Select a group</option>
                    <option v-for="group in groups" :key="group.id" :value="group.id">
                        {{ group.name }}
                    </option>
                </select>
                <div v-if="errors.group_id" class="error-message">{{ errors.group_id[0] }}</div>
            </div>

            <!-- New Fields -->
            <label>Medicine Name</label>
            <input type="text" v-model="student.medicine_name" placeholder="e.g. Methadone">
            <div v-if="errors.medicine_name" class="error-message">{{ errors.medicine_name[0] }}</div>

            <label>Dose (mg)</label>
            <input type="text" v-model="student.dose" placeholder="e.g. 30">
            <div v-if="errors.dose" class="error-message">{{ errors.dose[0] }}</div>

            <label>Admission Date</label>
            <input type="date" v-model="student.admission_date">
            <div v-if="errors.admission_date" class="error-message">{{ errors.admission_date[0] }}</div>

            <!-- Signature -->
            <!-- <div class="signature-box">
                <label>Client Signature:</label>
                <VueSignaturePad ref="signaturePad" width="100%" height="200px" class="signature-canvas" />
                <button type="button" @click="clearSignature" class="btn-clear mb-2 round-border">Clear
                    Signature</button>
            </div> -->

            <!-- Buttons -->
            <div class="btn-group mt-3">
                <button type="submit" class="btn btn-sm btn-primary me-2" style="min-width: 150px;">
                    {{ isEditing ? 'Update' : 'Add' }}
                </button>
                <button type="button" class="btn btn-sm btn-secondary cancel-btn" style="min-width: 150px;"
                    @click="$router.push({ name: 'StudentsIndex' })">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
// import { VueSignaturePad } from "vue-signature-pad";

export default {
    // components: { VueSignaturePad },
    data() {
        return {
            student: {
                name: '', email: '', course: '',
                pin_code: '', password: '', signature: '',
                id: 0, student_id: '', dob: '', pid: '',
                group_id: '', counselor_id: '', student_type: 'IOP',
                dose: '', admission_date: '', medicine_name: ''
            },
            isEditing: false,
            groups: [],
            counselors: [],
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        nameToEmail(name, pid) {
            if (!name) return '';
            const cleanName = name.trim().toLowerCase().replace(/\s+/g, '.').replace(/[^a-z.]/g, '');
            return `${cleanName + pid}@ptr.com`;
        },
        clearSignature() {
            this.$refs.signaturePad.clearSignature();
        },
        generatePassword(length = 12) {
            const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=';
            return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
        },
        dataURLtoBlob(dataURL) {
            if (!dataURL || !dataURL.includes(',')) return null;
            const [header, base64] = dataURL.split(',');
            const mime = header.match(/:(.*?);/)[1];
            const binary = atob(base64);
            const array = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                array[i] = binary.charCodeAt(i);
            }
            return new Blob([array], { type: mime });
        },
        async saveStudent() {
            // const signatureData = this.$refs.signaturePad.adsaveSignature();
            const formData = new FormData();

            // Append basic fields
            formData.append("name", this.student.name);
            formData.append("id", this.student.id);
            formData.append("student_id", this.student.student_id);
            formData.append("email", this.nameToEmail(this.student.name, this.student.pid));
            formData.append("course", this.student.course);
            formData.append("pin_code", this.student.pid);
            formData.append("dob", this.student.dob);
            formData.append("password", this.generatePassword());
            formData.append("pid", this.student.pid);
            formData.append("student_type", this.student.student_type);
            formData.append("dose", this.student.dose);
            formData.append("medicine_name", this.student.medicine_name);
            formData.append("admission_date", this.student.admission_date);

            if (this.student.student_type === 'OTP') {
                formData.append("counselor_id", this.student.counselor_id);
            } else {
                formData.append("group_id", this.student.group_id);
            }

            // ✅ Handle signature
            // if (signatureData?.data && signatureData.data.startsWith('data:image')) {
            //     const blob = this.dataURLtoBlob(signatureData.data);
            //     console.log('Signature Blob:', blob);
            //     if (blob instanceof Blob && blob.size > 0) {
            //         formData.append("signature", blob, "signature.png");
            //     } else {
            //         console.warn("Signature blob is invalid or empty.");
            //     }
            // }

            // ✅ Debug log of all form data
            console.log('FormData entries:');
            for (const [key, value] of formData.entries()) {
                console.log(key, value);
            }

            try {
                if (this.isEditing) {
                    formData.append('_method', 'PUT');
                    await this.$api.post(`/students/${this.$route.params.id}`, formData, {
                        headers: {
                            ...this.$api.defaults.headers.common
                        }
                    });
                } else {
                    await this.$api.post('/students', formData, {
                        headers: {
                            ...this.$api.defaults.headers.common
                        }
                    });
                }

                this.$router.push({ name: 'StudentsIndex' });
            } catch (error) {
                if (error.response?.status === 422) {
                    const errors = error.response.data.errors;
                    if (errors.email?.includes("The email has already been taken.")) {
                        this.errorMessage = "A student with the same PID or name already exists.";
                    } else {
                        this.errors = errors; // show individual field errors if needed
                    }


                } else {
                    this.errorMessage = 'An error occurred while saving the student. Please try again later.';
                }
            }
        }

        ,
        async fetchStudent() {
            if (this.$route.params.id) {
                this.isEditing = true;
                try {
                    const { data } = await this.$api.get(`/students/${this.$route.params.id}`);
                    this.student = {
                        ...data.user,
                        course: data.course,
                        pin_code: data.pid,
                        student_id: data.id,
                        pid: data.pid,
                        group_id: data.group_id,
                        counselor_id: data.counselor_id,
                        student_type: data.student_type,
                        dob: data.dob,
                        dose: data.dose,
                        admission_date: data.admission_date,
                        medicine_name: data.medicine_name
                    };
                    if (data.signature_url && this.$refs.signaturePad) {
                        // Draw the existing base64 signature onto the canvas
                        this.$nextTick(() => {
                            this.$refs.signaturePad.fromDataURL(data.signature_url);
                        });
                    }
                } catch (error) {
                    this.errorMessage = 'Error fetching student data.';
                }
            }
        },
        async fetchGroups() {
            const { data } = await this.$api.get('/groups');
            this.groups = data;
        },
        async fetchCounselors() {
            const { data } = await this.$api.get('/counselors');
            this.counselors = data;
        }
    },
    mounted() {
        this.fetchStudent();
        this.fetchGroups();
        this.fetchCounselors();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.signature-box {
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 20px;
    text-align: center;
}

.signature-canvas {
    border: 1px solid #000;
    width: 100%;
    height: 200px;
}

.btn-clear {
    margin-top: 10px;
    background-color: red;
    color: white;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 5px;
}
</style>
